import React from 'react';
import { Section } from './ui/Section';
import { Target, Layout, Eye, ShieldCheck } from 'lucide-react';
export function Solution() {
  return <Section id="solucion" className="bg-[#0F1525] relative border-y border-white/5" data-id="element-304">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-accent/5 via-transparent to-transparent opacity-50" data-id="element-305"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-306">
        <div className="text-center mb-16" data-id="element-307">
          <p className="text-brand-accent font-semibold tracking-wider uppercase mb-4" data-id="element-308">
            Lo que realmente necesitas no es solo diseño.
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-309">
            Presentando: El Sistema de Autoridad Digital
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed" data-id="element-310">
            Un activo estratégico construido específicamente para que
            emprendedores de servicios como tú sean percibidos como los
            referentes de su industria — y atraigan clientes de calidad de forma
            constante.
          </p>
        </div>

        <div className="bg-brand-surface border border-white/10 rounded-3xl p-8 mb-16 text-center" data-id="element-311">
          <ShieldCheck className="w-12 h-12 text-brand-accent mx-auto mb-4" data-id="element-312" />
          <p className="text-xl font-medium text-white" data-id="element-313">
            Este no es un sistema de diseño. Es un sistema de posicionamiento,
            persuasión y conversión que convierte a visitantes fríos en
            prospectos calientes.
          </p>
        </div>

        <div className="mb-16" data-id="element-314">
          <h3 className="text-2xl font-bold text-center mb-10" data-id="element-315">
            Cada elemento de tu web es construido con un propósito específico:
          </h3>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-316">
            <div className="bg-brand-dark border border-white/5 p-8 rounded-2xl hover:-translate-y-1 transition-transform" data-id="element-317">
              <Target className="w-10 h-10 text-brand-accent mb-6" data-id="element-318" />
              <h4 className="text-xl font-bold text-white mb-4" data-id="element-319">
                Cada palabra
              </h4>
              <p className="text-slate-400" data-id="element-320">
                Está diseñada para conectar con el dolor de tu cliente ideal y
                posicionarte como la solución obvia.
              </p>
            </div>

            <div className="bg-brand-dark border border-white/5 p-8 rounded-2xl hover:-translate-y-1 transition-transform" data-id="element-321">
              <Layout className="w-10 h-10 text-brand-accent mb-6" data-id="element-322" />
              <h4 className="text-xl font-bold text-white mb-4" data-id="element-323">
                Cada sección
              </h4>
              <p className="text-slate-400" data-id="element-324">
                Guía psicológicamente al visitante hacia una sola acción:
                contactarte a ti.
              </p>
            </div>

            <div className="bg-brand-dark border border-white/5 p-8 rounded-2xl hover:-translate-y-1 transition-transform" data-id="element-325">
              <Eye className="w-10 h-10 text-brand-accent mb-6" data-id="element-326" />
              <h4 className="text-xl font-bold text-white mb-4" data-id="element-327">
                Cada detalle visual
              </h4>
              <p className="text-slate-400" data-id="element-328">
                Comunica autoridad, confianza y profesionalismo desde el primer
                segundo.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center bg-gradient-to-r from-brand-surface via-brand-surface/80 to-brand-surface border border-white/10 p-8 rounded-2xl" data-id="element-329">
          <p className="text-2xl font-bold text-white leading-relaxed" data-id="element-330">
            El resultado es una presencia digital que trabaja por ti{' '}
            <span className="text-brand-accent" data-id="element-331">
              24 horas al día, 7 días a la semana
            </span>{' '}
            — incluso cuando tú estás durmiendo, de vacaciones, o atendiendo a
            otros clientes.
          </p>
        </div>
      </div>
    </Section>;
}